import { render, staticRenderFns } from "./DepositPaymentsModal.vue?vue&type=template&id=2b6c1790&scoped=true&"
import script from "./DepositPaymentsModal.vue?vue&type=script&lang=ts&"
export * from "./DepositPaymentsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6c1790",
  null
  
)

export default component.exports